export interface DramaEpisode {
  no: number;
  title: string;
  synopsis: string;
}

export interface Drama {
  id: string;
  title: string;
  poster: string;
  backdrop: string;
  summary: string;
  synopsis: string;
  director: string;
  writer: string;
  cast: string[];
  year: number;
  region: string;
  tags: string[];
  rating: number;
  popularity: number;
  updateDate: string;
  status: string;
  isClassic: boolean;
  episodes: DramaEpisode[];
}

const ep = (no: number, title: string, synopsis: string): DramaEpisode => ({ no, title, synopsis });

export const dramas: Drama[] = [
  {
    id: 'chidao-zhi-nan',
    title: '迟到的问答',
    poster: 'https://readdy.ai/api/search-image?query=Cinematic%20drama%20poster%20of%20a%20single%20woman%20in%20a%20deep%20red%20coat%20standing%20in%20an%20empty%20courtyard%20at%20dusk%2C%20moody%20dark%20maroon%20and%20warm%20amber%20tones%2C%20muted%20film%20grain%2C%20editorial%20photography%2C%20soft%20rim%20light%2C%20serious%20melancholic%20atmosphere&width=600&height=900&seq=ethics-poster-01&orientation=portrait',
    backdrop: 'https://readdy.ai/api/search-image?query=Atmospheric%20cinematic%20wide%20shot%20of%20a%20quiet%20old%20Chinese%20courtyard%20house%20at%20dusk%20with%20deep%20crimson%20curtains%20and%20dusty%20amber%20light%20through%20wooden%20latticed%20windows%2C%20silhouette%20of%20a%20woman%20in%20the%20doorway%2C%20dark%20maroon%20color%20palette%2C%20artistic%20film%20still%2C%20heavy%20shadows%2C%20moody%20atmosphere&width=1600&height=900&seq=ethics-hero-01&orientation=landscape',
    summary: '一场迟到了三十年的家庭问询，让三兄妹在旧宅里重新面对父亲留下的秘密。',
    synopsis:
      '父亲去世后的第七天，三兄妹回到城郊的老宅清点遗物。一份未寄出的信件揭开了一段被刻意掩埋的往事：三十年前，父亲为了保住家业，做出了一个伤害所有人的决定。长姐林知秋选择沉默，二哥林知远愤而出走，最小的妹妹林知夏则一直活在善意的谎言之中。当真相被逐层剥开，三个人不得不面对各自的怯懦与愧疚。剧集以克制的镜头语言和大量留白，探讨亲情与责任之间那条模糊的界线。',
    director: '沈砚舟',
    writer: '许闻秋',
    cast: ['周亦然', '林慕白', '苏念', '陈识远'],
    year: 2024,
    region: '中国大陆',
    tags: ['家庭', '亲情', '悬疑'],
    rating: 8.7,
    popularity: 96,
    updateDate: '2024-09-18',
    status: '全12集',
    isClassic: false,
    episodes: [
      ep(1, '第七天', '三兄妹回到老宅，雨夜里母亲的照片从墙上滑落。'),
      ep(2, '未寄出的信', '林知夏在阁楼发现一封写给陌生人的信，署名是父亲。'),
      ep(3, '长姐的沉默', '知秋拒绝了弟弟的追问，独自去见了当年的老会计。'),
      ep(4, '出走那一年', '知远回忆起十九岁那年的雪，和父亲摔碎的那只茶碗。'),
      ep(5, '善意的谎言', '母亲生前的日记显示，她早已知道一切。'),
      ep(6, '账本', '账本上的一个名字让三兄妹第一次发生激烈争吵。'),
      ep(7, '陌生人', '信中的收信人出现，带来另一段版本的往事。'),
      ep(8, '老宅的钥匙', '知秋把钥匙交给了弟弟，也交出了替父亲守了三十年的秘密。'),
      ep(9, '谁该道歉', '三人坐在空荡的客厅，第一次认真讨论什么叫做责任。'),
      ep(10, '雨停了', '雨停之后，知远在院子里挖出了父亲埋下的铁盒。'),
      ep(11, '迟到的回答', '铁盒里的录音带，是父亲迟到了三十年的回答。'),
      ep(12, '各自的家', '老宅挂牌出售，三兄妹在门口拍了最后一张合影。'),
    ],
  },
  {
    id: 'wu-hou-de-hai',
    title: '雾后的海',
    poster: 'https://readdy.ai/api/search-image?query=Cinematic%20drama%20poster%20of%20a%20woman%20standing%20on%20a%20foggy%20seaside%20pier%20wearing%20a%20cream%20knit%20sweater%2C%20thick%20grey%20mist%20over%20dark%20sea%2C%20muted%20warm%20beige%20and%20charcoal%20tones%2C%20arthouse%20film%20poster%20aesthetic%2C%20soft%20diffused%20light%2C%20lonely%20contemplative%20mood&width=600&height=900&seq=ethics-poster-02&orientation=portrait',
    backdrop: 'https://readdy.ai/api/search-image?query=Wide%20cinematic%20shot%20of%20a%20foggy%20coastal%20town%20at%20blue%20hour%20with%20a%20lone%20woman%20walking%20along%20a%20wet%20pier%2C%20dense%20mist%20over%20deep%20charcoal%20sea%2C%20muted%20warm%20beige%20highlights%2C%20subtle%20crimson%20lantern%20glow%2C%20artistic%20film%20still%2C%20melancholic%20cinematic%20atmosphere&width=1600&height=900&seq=ethics-hero-02&orientation=landscape',
    summary: '渔村的雾季里，一位归乡的女教师与旧日恋人重逢，也撞见了小镇集体守口如瓶的秘密。',
    synopsis:
      '离乡十年的乔知微回到海湾镇的中学任教。她原本只想照顾病重的母亲，却在一次家访中得知，十年前那场让整座小镇沉默的海难另有隐情。旧日恋人周予岸如今是镇上的渔业管理员，他劝她不要追问。可越是靠近真相，乔知微越发现母亲、校长甚至自己都曾参与这场沉默。这部剧以海浪与雾气为意象，讲述一个人在私情与公义之间的摇摆，以及原谅是否真的必要。',
    director: '郑北川',
    writer: '陆时雨',
    cast: ['许嘉禾', '顾晏清', '叶秋池'],
    year: 2023,
    region: '中国大陆',
    tags: ['悬疑', '都市', '情感'],
    rating: 8.4,
    popularity: 88,
    updateDate: '2023-11-02',
    status: '全16集',
    isClassic: false,
    episodes: [
      ep(1, '归乡', '乔知微带着行李回到海湾镇，码头上的雾比记忆中更厚。'),
      ep(2, '旧同学', '周予岸在市场上认出了她，两人寒暄得像陌生人。'),
      ep(3, '家访', '一个学生的作文里，写到了十年前的那艘船。'),
      ep(4, '母亲的手', '知微发现母亲的右手至今无法拿起筷子。'),
      ep(5, '镇上的规矩', '校长委婉提醒她，有些事不必教给学生。'),
      ep(6, '退潮', '退潮之后，海滩上露出了不属于渔船的物件。'),
      ep(7, '予岸', '周予岸第一次说出自己的立场，也第一次请求她离开。'),
      ep(8, '雾季', '大雾封海三天，镇上的气氛越来越紧。'),
      ep(9, '匿名电话', '知微接到一个只说了三个字就挂断的电话。'),
      ep(10, '名单', '她在旧档案室找到了一份没有名字的名单。'),
      ep(11, '母亲的证词', '母亲终于开口，说出那天自己在船上看到的东西。'),
    ],
  },
  {
    id: 'hong-mu',
    title: '红幕',
    poster: 'https://readdy.ai/api/search-image?query=Cinematic%20poster%20of%20a%20lone%20actress%20in%20a%20burgundy%20silk%20qipao%20standing%20on%20an%20empty%20theatre%20stage%20under%20a%20single%20spotlight%2C%20deep%20red%20velvet%20curtains%2C%20art%20deco%20details%2C%20rich%20maroon%20and%20warm%20gold%20tones%2C%20dramatic%20theatrical%20lighting%2C%20elegant%20cinematic%20portrait&width=600&height=900&seq=ethics-poster-03&orientation=portrait',
    backdrop: 'https://readdy.ai/api/search-image?query=Dramatic%20cinematic%20view%20of%20an%20empty%20vintage%20theatre%20with%20deep%20red%20velvet%20seats%20and%20heavy%20burgundy%20curtains%2C%20single%20warm%20gold%20spotlight%20on%20a%20dusty%20stage%2C%20atmospheric%20haze%2C%20rich%20maroon%20and%20amber%20palette%2C%20art%20deco%20architecture%2C%20elegant%20moody%20film%20still&width=1600&height=900&seq=ethics-hero-03&orientation=landscape',
    summary: '剧团重排经典悲剧，女主角却发现剧本里的台词，正是自己母亲未说出口的一生。',
    synopsis:
      '省城话剧团准备重排一部三十年前的禁演剧本《红幕》。年轻演员沈青禾被选中出演女主角，排练过程中她渐渐意识到，剧本的作者正是自己的母亲，而故事里那个被众人指责的女人，就是母亲年轻时的自己。随着排练的深入，导演、老演员与团长的旧日恩怨也浮出水面。舞台上的虚构与舞台下的人生逐渐重叠，沈青禾必须决定：是演完这场戏，还是在开演之夜说出全部真相。',
    director: '闻人朗',
    writer: '沈青禾',
    cast: ['白沁', '姜淳之', '罗一鸣'],
    year: 2022,
    region: '中国大陆',
    tags: ['剧场', '家族', '文艺'],
    rating: 8.9,
    popularity: 82,
    updateDate: '2022-06-21',
    status: '全10集',
    isClassic: true,
    episodes: [
      ep(1, '重排', '剧团宣布复排《红幕》，排练厅里一片哗然。'),
      ep(2, '女主角', '沈青禾拿到剧本，读到第一页就停不下来。'),
      ep(3, '旧照片', '老化妆师认出了她的眉心，说像极了三十年前的某人。'),
      ep(4, '禁演的原因', '团长含糊其辞，只说当年出了些事故。'),
      ep(5, '母亲的处女作', '青禾在旧书摊找到剧本的第一版单行本。'),
      ep(6, '排位', '演员之间为了戏份暗自较劲，矛盾首次公开。'),
      ep(7, '第三幕', '第三幕的台词让青禾在排练中失声。'),
      ep(8, '开演前三小时', '导演把剪掉的段落交还给她，说这是本剧的心。'),
      ep(9, '红幕升起', '她选择把整段台词念完，台下坐着一位不该来的人。'),
      ep(10, '谢幕', '谢幕之后，剧场里只剩下母亲的一个旧座位。'),
    ],
  },
  {
    id: 'jiu-lou-de-deng',
    title: '九楼的灯',
    poster: 'https://readdy.ai/api/search-image?query=Cinematic%20poster%20of%20a%20man%20in%20a%20dark%20coat%20standing%20in%20the%20corridor%20of%20an%20old%20apartment%20building%20lit%20by%20a%20single%20warm%20lamp%2C%20deep%20shadows%2C%20maroon%20and%20dull%20amber%20tones%2C%20urban%20noir%20film%20poster%20aesthetic%2C%20tight%20composition%2C%20quiet%20tension&width=600&height=900&seq=ethics-poster-04&orientation=portrait',
    backdrop: 'https://readdy.ai/api/search-image?query=Cinematic%20wide%20shot%20of%20an%20old%20city%20apartment%20block%20at%20night%2C%20one%20window%20glowing%20warm%20amber%20on%20the%20ninth%20floor%2C%20rain%20slick%20street%20below%2C%20deep%20maroon%20and%20charcoal%20color%20palette%2C%20neon%20glow%20reflections%2C%20urban%20noir%20atmosphere%2C%20film%20still&width=1600&height=900&seq=ethics-hero-04&orientation=landscape',
    summary: '同一栋旧楼的九个家庭，围绕一盏走廊感应灯，串起九段彼此牵连的人情与秘密。',
    synopsis:
      '老城区一栋即将拆迁的居民楼，九楼的走廊声控灯坏了很久，谁都不愿意出钱修。一个小小的公共问题，逐渐牵扯出九户人家的生活：独居老人与不常回家的儿子、偷偷收留流浪猫的年轻夫妻、在楼道里摆摊的中年妇人、总在深夜练琴的艺考生。每集以一个家庭为单位，走廊那盏灯时亮时灭，照见的是普通人之间最难说清的道义与分寸。',
    director: '石广年',
    writer: '何砚',
    cast: ['梁书臣', '范沉', '袁巧', '彭立冬'],
    year: 2021,
    region: '中国大陆',
    tags: ['群像', '都市', '现实'],
    rating: 8.2,
    popularity: 74,
    updateDate: '2021-04-12',
    status: '全9集',
    isClassic: true,
    episodes: [
      ep(1, '坏掉的声控灯', '九楼走廊的灯又灭了，第一次有人提议凑钱。'),
      ep(2, '三零二', '独居老人的儿子在电话里说自己很忙。'),
      ep(3, '流浪猫', '年轻夫妻为了猫与邻居第一次起争执。'),
      ep(4, '楼道摊', '中年妇人的生意被投诉，她决定不再摆摊。'),
      ep(5, '练琴的夜', '艺考生在深夜练琴，楼下的灯替她挡下了一次投诉。'),
      ep(6, '拆迁通知', '拆迁通知贴上门，所有积压的对话被迫摊开。'),
      ep(7, '灯亮了', '灯终于被修好，亮起的那一刻却没人抬头。'),
      ep(8, '搬走', '第一个搬走的人给邻居留下了自己的钥匙。'),
      ep(9, '最后一夜', '走廊里最后一场对话，发生在灯再次熄灭的时候。'),
    ],
  },
  {
    id: 'qing-chen-de-an-jian',
    title: '清晨的案件',
    poster: 'https://readdy.ai/api/search-image?query=Cinematic%20drama%20poster%20of%20a%20female%20detective%20in%20a%20beige%20trench%20coat%20standing%20outside%20a%20small-town%20house%20at%20early%20dawn%2C%20soft%20pale%20golden%20light%2C%20muted%20beige%20and%20deep%20rust%20palette%2C%20understated%20thriller%20film%20poster%20aesthetic%2C%20calm%20determined%20mood&width=600&height=900&seq=ethics-poster-05&orientation=portrait',
    backdrop: 'https://readdy.ai/api/search-image?query=Cinematic%20wide%20shot%20of%20a%20small%20town%20street%20at%20early%20dawn%20with%20pale%20golden%20sunlight%20and%20long%20shadows%2C%20a%20woman%20in%20a%20beige%20coat%20walking%20toward%20a%20low%20house%2C%20deep%20rust%20and%20warm%20beige%20palette%2C%20quiet%20tension%2C%20artistic%20film%20still%2C%20soft%20morning%20haze&width=1600&height=900&seq=ethics-hero-05&orientation=landscape',
    summary: '一起看似普通的民事纠纷，让回乡协助调查的检察官重新审视自己对这个小镇的所有判断。',
    synopsis:
      '检察官顾清在休假期间回到小镇，卷入一起牵涉邻里纠纷的伤害案。案子不大，可当事人之间的关系却像一张密不透风的网。随着走访的深入，她发现案件背后牵着一桩多年前被和稀泥处理的事故，而当年处理事故的人，正是她最敬重的老师。剧集以冷静的节奏探讨程序正义与人情社会的碰撞，也追问一个执法者在面对至亲时还能否保持公正。',
    director: '徐照',
    writer: '温慕白',
    cast: ['单青', '许砚清', '骆鸣'],
    year: 2020,
    region: '中国大陆',
    tags: ['现实', '悬疑', '法治'],
    rating: 8.0,
    popularity: 69,
    updateDate: '2020-08-30',
    status: '全14集',
    isClassic: true,
    episodes: [
      ep(1, '清晨六点', '顾清在小镇的菜市场听见一声争吵。'),
      ep(2, '不像案件', '派出所想把事情压成简单的邻里纠纷。'),
      ep(3, '当事人', '受伤的妇人不愿开口，只说自己也有些错。'),
      ep(4, '旧事故', '走访中，有人提起了几年前的另一件事。'),
      ep(5, '老师', '顾清去拜访老师，客厅里的茶已经凉了。'),
      ep(6, '一页笔录', '档案里少了一页关键的笔录。'),
      ep(7, '证人的犹豫', '唯一的证人换了三次证词。'),
      ep(8, '程序', '老师劝她，小镇有小镇的处理方式。'),
      ep(9, '回避申请', '她主动提交了回避申请，却在走廊里停下了。'),
      ep(10, '重新开始', '案件重新立案，事情才真正开始变得艰难。'),
    ],
  },
  {
    id: 'xiang-si-ji',
    title: '乡思记',
    poster: 'https://readdy.ai/api/search-image?query=Cinematic%20poster%20of%20a%20middle-aged%20farmer%20standing%20in%20a%20golden%20rice%20field%20at%20sunset%2C%20warm%20harvest%20light%2C%20faded%20rust%20and%20gold%20tones%2C%20earthy%20realist%20film%20poster%20aesthetic%2C%20soft%20evening%20glow%2C%20dignified%20quiet%20expression&width=600&height=900&seq=ethics-poster-06&orientation=portrait',
    backdrop: 'https://readdy.ai/api/search-image?query=Sweeping%20cinematic%20shot%20of%20terraced%20rice%20fields%20at%20golden%20hour%20in%20a%20mountain%20village%2C%20warm%20rust%20and%20deep%20amber%20tones%2C%20a%20small%20figure%20walking%20along%20a%20narrow%20path%2C%20soft%20dust%20in%20the%20air%2C%20realist%20film%20still%2C%20nostalgic%20serene%20atmosphere&width=1600&height=900&seq=ethics-hero-06&orientation=landscape',
    summary: '为了守住父亲留下的三亩地，一个男人与全村人打了一场漫长而体面的官司。',
    synopsis:
      '在外打工多年的黄立生回到家乡，发现父亲留下的三亩地被村里划给了新建的厂区。他不吵不闹，只是逐条查法规、找证据，把村委告上了法庭。乡亲们起初看笑话，后来渐渐沉默。妻子不理解他为何要坚持，儿子在学校也遭到排挤。这是一部关于土地、尊严与乡土伦理的剧集，讲一个人如何用最笨的方法，守住他认为不能被占走的东西。',
    director: '秦守拙',
    writer: '秦守拙',
    cast: ['贾立群', '宋知微', '王耀东'],
    year: 2019,
    region: '中国大陆',
    tags: ['乡土', '家庭', '现实'],
    rating: 8.6,
    popularity: 63,
    updateDate: '2019-03-15',
    status: '全11集',
    isClassic: true,
    episodes: [
      ep(1, '回家', '黄立生提着行李回到村口，田里立着施工的旗子。'),
      ep(2, '地契', '父亲的地契被压在旧木箱的最底下。'),
      ep(3, '村里开会', '乡亲们劝他别较真，说这是为了全村好。'),
      ep(4, '第一份材料', '他在镇上打印店花了四十块钱。'),
      ep(5, '妻子的意见', '妻子第一次摔了碗。'),
      ep(6, '儿子的委屈', '儿子在学校被同学围住。'),
      ep(7, '开庭', '只有他一个人坐在原告席上。'),
      ep(8, '邻居的证词', '沉默多年的邻居站了出来。'),
      ep(9, '调解', '法官主持调解，双方都不肯先低头。'),
      ep(10, '秋收', '案子还没结束，田里的稻子先熟了。'),
      ep(11, '三亩地', '判决下来那天，他一个人在田埂上坐到天黑。'),
    ],
  },
  {
    id: 'ye-xing-ren',
    title: '夜行人',
    poster: 'https://readdy.ai/api/search-image?query=Cinematic%20noir%20poster%20of%20a%20woman%20in%20a%20dark%20coat%20walking%20alone%20through%20a%20rainy%20old%20city%20alley%20at%20night%2C%20amber%20streetlight%20behind%20her%2C%20deep%20maroon%20and%20black%20tones%2C%20neon%20reflections%20on%20wet%20stone%2C%20moody%20detective%20drama%20aesthetic&width=600&height=900&seq=ethics-poster-07&orientation=portrait',
    backdrop: 'https://readdy.ai/api/search-image?query=Rainy%20night%20in%20an%20old%20city%20alley%20with%20deep%20maroon%20neon%20signs%20and%20amber%20streetlights%2C%20wet%20cobblestones%20reflecting%20light%2C%20a%20solitary%20figure%20walking%20away%2C%20dark%20cinematic%20noir%20film%20still%2C%20heavy%20contrast%2C%20atmospheric%20mist&width=1600&height=900&seq=ethics-hero-07&orientation=landscape',
    summary: '一个只在夜里工作的人，用她的方式替那些无处申诉的人讨回一点公道。',
    synopsis:
      '许听澜白天是社区图书馆的管理员，夜里则替人写申诉材料、整理证据。她从不出面，也不要报酬，只在长夜里替那些求助无门的人把话写清楚。一个年轻女孩的求助，让她不得不面对自己当年沉默的那件事。剧集以冷峻的影像与克制的对白，讲述一个人在漫长的夜色里如何与自己的愧疚相处，并最终选择走到光里。',
    director: '娄静川',
    writer: '沈月白',
    cast: ['温彤', '简野', '牟清'],
    year: 2024,
    region: '中国大陆',
    tags: ['都市', '悬疑', '女性'],
    rating: 8.3,
    popularity: 91,
    updateDate: '2024-08-06',
    status: '更新至08集',
    isClassic: false,
    episodes: [
      ep(1, '图书馆的最后一个读者', '闭馆前，一个女孩把一叠材料放在她桌上。'),
      ep(2, '第一份材料', '她改到凌晨三点，删掉了所有形容情绪的句子。'),
      ep(3, '旧案', '女孩的哥哥三年前出过一次事。'),
      ep(4, '代写', '她第一次用了别人的名字。'),
      ep(5, '被跟踪', '回家的路上，她发现身后一直有人。'),
      ep(6, '沉默的证人', '证人只在深夜里接电话。'),
      ep(7, '那一晚', '她终于说出自己当年看到的东西。'),
      ep(8, '天亮之前', '她决定第一次以真名出现在现场。'),
    ],
  },
  {
    id: 'chun-shan-ru-xu',
    title: '春山如许',
    poster: 'https://readdy.ai/api/search-image?query=Cinematic%20period%20poster%20of%20a%20scholar%20woman%20in%20simple%20linen%20robe%20standing%20on%20a%20spring%20mountain%20path%20with%20white%20blossoms%2C%20soft%20misty%20green%20and%20warm%20cream%20tones%2C%20elegant%20classic%20chinese%20aesthetic%2C%20delicate%20natural%20light%2C%20poetic%20serene%20mood&width=600&height=900&seq=ethics-poster-08&orientation=portrait',
    backdrop: 'https://readdy.ai/api/search-image?query=Poetic%20cinematic%20landscape%20of%20spring%20mountains%20in%20soft%20mist%20with%20blooming%20white%20blossom%20trees%20and%20a%20stone%20path%2C%20gentle%20warm%20light%2C%20muted%20sage%20green%20and%20cream%20palette%20with%20subtle%20crimson%20accents%2C%20classic%20chinese%20painting%20composition%2C%20tranquil%20atmosphere&width=1600&height=900&seq=ethics-hero-08&orientation=landscape',
    summary: '民国小镇上，一位女先生为了留住一间女子学堂，与整个家族的规矩正面相撞。',
    synopsis:
      '民国二十三年，留洋归来的女子程如许回到故乡，接手了姑姑留下的一间小学堂。她想让镇上的女孩读书识字，却触动了几十年来根深蒂固的规矩。夫家、族老、甚至是自己的母亲都站在她的对立面。唯一支持她的，是镇上一位沉默的教书先生。在理想与亲情的拉扯中，程如许必须决定自己究竟要成为谁。剧集以细腻的笔触描绘一代女性在旧秩序中的挣扎与觉醒。',
    director: '章怀玉',
    writer: '程门雪',
    cast: ['宋栖迟', '顾长风', '岑宛'],
    year: 2018,
    region: '中国大陆',
    tags: ['年代', '女性', '家族'],
    rating: 9.1,
    popularity: 79,
    updateDate: '2018-05-20',
    status: '全20集',
    isClassic: true,
    episodes: [
      ep(1, '归乡', '程如许提着皮箱走下船，镇口立着新修的牌坊。'),
      ep(2, '学堂', '姑姑留下的学堂只剩七个学生。'),
      ep(3, '族老', '族老说，女娃识字没有用处。'),
      ep(4, '第九个学生', '一个卖菜的女孩偷偷站在窗外听课。'),
      ep(5, '母亲的眼泪', '母亲第一次求她放弃。'),
      ep(6, '教书先生', '沉默的先生在黑板上写下第一个字。'),
      ep(7, '退婚', '夫家把聘礼抬了回去。'),
      ep(8, '春山', '她带着学生去山上认植物。'),
      ep(9, '一场雨', '学堂的屋顶漏了，全镇人都在看。'),
      ep(10, '如许', '她终于明白，姑姑当年为什么没有走。'),
    ],
  },
  {
    id: 'yi-jian-fang',
    title: '一间房',
    poster: 'https://readdy.ai/api/search-image?query=Cinematic%20poster%20of%20a%20young%20couple%20standing%20in%20a%20small%20rented%20room%20with%20warm%20afternoon%20sunlight%20through%20thin%20curtains%2C%20muted%20terracotta%20and%20cream%20palette%2C%20intimate%20realist%20drama%20aesthetic%2C%20delicate%20emotional%20atmosphere&width=600&height=900&seq=ethics-poster-09&orientation=portrait',
    backdrop: 'https://readdy.ai/api/search-image?query=Cinematic%20interior%20of%20a%20small%20old%20rented%20apartment%20room%20with%20warm%20afternoon%20sunlight%20through%20lace%20curtains%2C%20muted%20terracotta%20and%20cream%20tones%2C%20lived-in%20details%2C%20soft%20dusty%20light%2C%20intimate%20realist%20film%20still%2C%20quiet%20melancholy&width=1600&height=900&seq=ethics-hero-09&orientation=landscape',
    summary: '一间只放得下一张床的出租屋，装下了两个年轻人所有关于未来的争执。',
    synopsis:
      '毕业三年，苏晚和陈述一直住在城郊一间不足十五平米的出租屋里。房租涨了三次，工作换了两回，两人的关系也在日复一日的精打细算中出现裂痕。当他们终于有机会搬进更大的房子时，却发现真正困住彼此的并不是这间房。剧集以极简的场景和大量对话，刻画当代年轻人在亲密关系里的诚实与逃避。',
    director: '林见白',
    writer: '林见白',
    cast: ['叶舟', '钟晴', '彭宇'],
    year: 2024,
    region: '中国大陆',
    tags: ['都市', '情感', '现实'],
    rating: 8.1,
    popularity: 85,
    updateDate: '2024-10-09',
    status: '更新至06集',
    isClassic: false,
    episodes: [
      ep(1, '十五平', '搬进来的第一天，两个人在地上吃了一顿火锅。'),
      ep(2, '涨租', '房东在门口贴了一张纸。'),
      ep(3, '加班', '陈述连续两周没有在十二点前回家。'),
      ep(4, '面试', '苏晚拿到一个更好的机会，却在门口犹豫了。'),
      ep(5, '一件旧家具', '他们为了要不要丢掉一张桌子吵了一架。'),
      ep(6, '看房', '新房子很亮，两个人都没有说话。'),
    ],
  },
  {
    id: 'fu-qin-de-shou',
    title: '父亲的手',
    poster: 'https://readdy.ai/api/search-image?query=Cinematic%20portrait%20poster%20of%20an%20elderly%20craftsman%20with%20weathered%20hands%20holding%20a%20woodworking%20tool%20in%20a%20dim%20workshop%2C%20warm%20amber%20and%20deep%20brown%20tones%2C%20respectful%20realist%20film%20poster%20aesthetic%2C%20soft%20side%20light%2C%20dignified%20quiet%20mood&width=600&height=900&seq=ethics-poster-10&orientation=portrait',
    backdrop: 'https://readdy.ai/api/search-image?query=Dim%20traditional%20woodworking%20workshop%20with%20warm%20amber%20light%20and%20floating%20dust%2C%20hands%20shaping%20a%20wooden%20piece%20on%20an%20old%20workbench%2C%20deep%20brown%20and%20crimson%20tones%2C%20textured%20realist%20film%20still%2C%20quiet%20craftsmanship%20atmosphere&width=1600&height=900&seq=ethics-hero-10&orientation=landscape',
    summary: '老木匠把一生手艺传给学徒，却始终没能跟自己唯一的儿子好好说上一句话。',
    synopsis:
      '七十岁的木匠陈守义在镇上开了一辈子作坊，手上功夫无人不服，唯独跟儿子陈越无法交流。儿子在城里做设计，觉得父亲的坚持是固执；父亲觉得儿子的工作虚无缥缈。一次意外让陈守义的手伤得不轻，他不得不请儿子回来帮忙完成最后一件订单。在一个屋檐下共处的三十天里，父子俩借助木头重新学会了说话。剧集以手艺为线索，讲述中国传统父子关系里最沉默的那部分情感。',
    director: '陆守拙',
    writer: '苏茂',
    cast: ['胡金生', '陈越白', '丁宛'],
    year: 2017,
    region: '中国大陆',
    tags: ['家庭', '亲情', '匠人'],
    rating: 8.8,
    popularity: 58,
    updateDate: '2017-10-11',
    status: '全12集',
    isClassic: true,
    episodes: [
      ep(1, '伤痕', '刨子从手里滑出去的那一刻，作坊里异常安静。'),
      ep(2, '回来', '陈越在电话里沉默了很久才答应。'),
      ep(3, '量尺', '父亲让他重新从量尺开始学起。'),
      ep(4, '第一次争吵', '儿子想用机器，父亲坚持用刨子。'),
      ep(5, '旧图样', '一本旧图样里夹着一张儿子小时候的画。'),
      ep(6, '母亲的话', '母亲第一次谈起父亲年轻时的事。'),
      ep(7, '客户的挑剔', '订做家具的人不断改要求。'),
      ep(8, '一道榫', '父子俩一起做出了整部剧里最漂亮的一道榫。'),
      ep(9, '手', '陈守义让儿子看自己的手，说完又沉默。'),
      ep(10, '交活', '家具交付那天，客户哭了。'),
      ep(11, '没说出口', '父亲在饭桌上说了一句极短的话。'),
      ep(12, '作坊的灯', '作坊的灯还亮着，只是换了一个人在用。'),
    ],
  },
  {
    id: 'san-ren-ju',
    title: '三人局',
    poster: 'https://readdy.ai/api/search-image?query=Cinematic%20poster%20of%20three%20people%20sitting%20around%20a%20dining%20table%20in%20a%20dim%20apartment%2C%20seen%20from%20behind%2C%20warm%20low%20lamp%20light%2C%20deep%20maroon%20and%20muted%20ochre%20palette%2C%20tense%20relationship%20drama%20aesthetic%2C%20shallow%20depth%20of%20field&width=600&height=900&seq=ethics-poster-11&orientation=portrait',
    backdrop: 'https://readdy.ai/api/search-image?query=Cinematic%20wide%20shot%20of%20a%20dim%20dining%20room%20at%20night%20with%20a%20long%20table%20and%20three%20empty%20chairs%2C%20warm%20low%20pendant%20lamps%2C%20deep%20maroon%20walls%2C%20shadows%20and%20dust%20in%20the%20air%2C%20tense%20chamber%20drama%20film%20still%2C%20rich%20ochre%20and%20bordeaux%20tones&width=1600&height=900&seq=ethics-hero-11&orientation=landscape',
    summary: '一场三人晚餐，把一段婚姻里所有没说完的话，都摆到了桌面上。',
    synopsis:
      '结婚十二年的夫妻，在一场晚餐上邀请了一位多年未见的老朋友。原本只是一次寻常的聚餐，却因为一句无心的提起，让三个人各自隐藏多年的心事浮出水面。剧集采用密室式的叙事结构，全部情节几乎都发生在同一张餐桌旁，靠台词与微表情推进张力，探讨婚姻中的诚实、情谊的边界与时间的重量。',
    director: '章北',
    writer: '顾南',
    cast: ['何清野', '佟晚', '孟川'],
    year: 2023,
    region: '中国大陆',
    tags: ['婚姻', '情感', '密室'],
    rating: 8.5,
    popularity: 77,
    updateDate: '2023-02-27',
    status: '全8集',
    isClassic: false,
    episodes: [
      ep(1, '晚餐开始', '门铃响的时候，桌上的菜刚刚上齐。'),
      ep(2, '一句提起', '老朋友说了一件谁都不想听的事。'),
      ep(3, '十二年前', '三个人开始回忆相识的那一年。'),
      ep(4, '沉默', '女主人起身去了厨房，很久没有回来。'),
      ep(5, '谁说的', '为了谁先说了那句话，两人第一次提高了声音。'),
      ep(6, '第三个人', '客人终于说出了他来这顿饭的真正原因。'),
      ep(7, '洗碗', '深夜里，两个人在厨房洗完了所有的碗。'),
      ep(8, '门关上以后', '灯光熄灭，桌上还剩三个杯子。'),
    ],
  },
  {
    id: 'cheng-shi-de-yu',
    title: '城市的雨',
    poster: 'https://readdy.ai/api/search-image?query=Cinematic%20poster%20of%20a%20delivery%20worker%20sheltering%20under%20a%20shop%20awning%20during%20heavy%20city%20rain%20at%20night%2C%20warm%20amber%20shop%20light%20and%20deep%20charcoal%20rain%2C%20realist%20urban%20drama%20aesthetic%2C%20reflective%20quiet%20mood&width=600&height=900&seq=ethics-poster-12&orientation=portrait',
    backdrop: 'https://readdy.ai/api/search-image?query=Rainy%20night%20street%20in%20a%20busy%20city%20with%20warm%20amber%20shopfront%20glow%20and%20deep%20charcoal%20wet%20road%2C%20reflections%20of%20light%2C%20blurred%20figures%20under%20umbrellas%2C%20muted%20rust%20and%20dark%20grey%20palette%2C%20cinematic%20realist%20film%20still%2C%20lonely%20atmosphere&width=1600&height=900&seq=ethics-hero-12&orientation=landscape',
    summary: '一个外卖骑手在暴雨夜接到的最后一单，改变了他和三个陌生人的命运。',
    synopsis:
      '骑手程野在暴雨夜接到一单奇怪的订单：送去一栋即将拆除的老楼，收件人写着三十年前的地址。追查地址的过程中，他遇见了独居的老太太、准备辞职的小护士、以及一个总在雨夜里站在路口的男人。四个陌生人的生活因为这场雨短暂交错，彼此留下一点微不足道却真实的温度。剧集以平视的镜头，记录城市角落里那些容易被忽略的人。',
    director: '严东',
    writer: '何清川',
    cast: ['陆野', '苏棠', '丁守一'],
    year: 2025,
    region: '中国大陆',
    tags: ['都市', '群像', '温情'],
    rating: 8.4,
    popularity: 93,
    updateDate: '2025-01-16',
    status: '更新至10集',
    isClassic: false,
    episodes: [
      ep(1, '最后一单', '暴雨中，系统给他派了一张写错地址的订单。'),
      ep(2, '三十年前的地址', '那栋楼已经贴上了拆迁的封条。'),
      ep(3, '老太太', '楼里还住着唯一的一位住户。'),
      ep(4, '小护士', '她在雨里站了很久，没有打伞。'),
      ep(5, '路口的人', '那个男人每天都站在同一个位置。'),
      ep(6, '一封信', '信封里的地址，指向这座城市另一端。'),
      ep(7, '雨停了', '雨停的第一个晚上，四个人第一次同桌吃饭。'),
      ep(8, '订单完成', '他把那封信亲手交到了收件人手里。'),
      ep(9, '搬家', '老太太终于同意搬去养老院。'),
      ep(10, '下一场雨', '又下雨了，路口空着。'),
    ],
  },
  {
    id: 'wu-yan-de-zhong',
    title: '无言的钟',
    poster: 'https://readdy.ai/api/search-image?query=Cinematic%20poster%20of%20an%20old%20wall%20clock%20and%20a%20solitary%20figure%20in%20a%20faded%20wool%20coat%20in%20a%20quiet%20room%2C%20deep%20umber%20and%20dusty%20gold%20tones%2C%20restrained%20literary%20drama%20aesthetic%2C%20soft%20window%20light%2C%20nostalgic%20mood&width=600&height=900&seq=ethics-poster-13&orientation=portrait',
    backdrop: 'https://readdy.ai/api/search-image?query=Cinematic%20interior%20of%20a%20quiet%20old%20study%20with%20a%20large%20stopped%20wall%20clock%2C%20dusty%20gold%20and%20deep%20umber%20tones%2C%20warm%20window%20light%20through%20gauze%20curtains%2C%20restrained%20literary%20film%20still%2C%20melancholic%20nostalgic%20atmosphere&width=1600&height=900&seq=ethics-hero-13&orientation=landscape',
    summary: '一座停摆的钟，守着一个家庭关于谅解的最后期限。',
    synopsis:
      '退休的钟表匠罗时安在妻子去世后，把家里所有的钟都停了。女儿罗念从外地赶回，本想处理完房子就走，却因为这座停摆的钟与父亲陷入了漫长的争执。父亲坚持修好它，女儿只想把它扔掉。在拆解钟芯的过程中，两人一点点整理出这个家庭被忽略的几十年。剧集以缓慢的节奏与安静的对话，讲述告别与和解。',
    director: '罗文起',
    writer: '罗文起',
    cast: ['秦时安', '祝念', '钟明远'],
    year: 2016,
    region: '中国大陆',
    tags: ['家庭', '亲情', '文艺'],
    rating: 8.7,
    popularity: 51,
    updateDate: '2016-12-03',
    status: '全9集',
    isClassic: true,
    episodes: [
      ep(1, '停摆', '家里所有的钟都停在了同一个时刻。'),
      ep(2, '回家', '罗念拖着行李箱推开门，屋里很安静。'),
      ep(3, '拆解', '父亲把钟的外壳取下来，让她看里面的齿轮。'),
      ep(4, '母亲的笔记', '一本记账本里记着每次争吵的日期。'),
      ep(5, '争吵', '女儿终于说出那句忍了很多年的话。'),
      ep(6, '齿轮', '父亲把一颗磨损的齿轮放在她手心。'),
      ep(7, '邻居', '邻居说起年轻时听到的那些声音。'),
      ep(8, '重新上弦', '钟摆开始动了，声音很轻。'),
      ep(9, '时间', '临走前，女儿把钥匙留在门框上。'),
    ],
  },
  {
    id: 'hui-jia-de-lu',
    title: '回家的路',
    poster: 'https://readdy.ai/api/search-image?query=Cinematic%20poster%20of%20a%20long%20country%20road%20at%20sunset%20with%20a%20woman%20carrying%20a%20small%20bag%20walking%20toward%20a%20village%2C%20warm%20rust%20and%20gold%20tones%2C%20dust%20in%20the%20air%2C%20humanist%20realist%20drama%20aesthetic%2C%20soft%20evening%20light&width=600&height=900&seq=ethics-poster-14&orientation=portrait',
    backdrop: 'https://readdy.ai/api/search-image?query=Long%20country%20road%20at%20sunset%20through%20dry%20grassland%20toward%20a%20distant%20village%2C%20warm%20rust%20and%20deep%20gold%20tones%2C%20dust%20haze%20in%20the%20air%2C%20small%20figure%20walking%2C%20humanist%20cinematic%20film%20still%2C%20wide%20open%20atmosphere&width=1600&height=900&seq=ethics-hero-14&orientation=landscape',
    summary: '失散二十年的母女重逢，彼此却已经叫不出对方的名字。',
    synopsis:
      '柳棠在福利院长大，成年后一直在寻找自己的母亲。二十五年后，她终于在一个偏远的乡镇找到了当年把自已送走的人。母亲已经再婚，有了新的家庭和一个年幼的儿子，并且坚持不认识她。柳棠没有揭穿，而是租下镇上的一间小屋，慢慢地靠近这个陌生又熟悉的家庭。剧集以克制的笔法，讲述亲情里最难处理的那一部分——被抛弃之后，还愿不愿意承认。',
    director: '路遥生',
    writer: '柳青禾',
    cast: ['柳棠', '范玉兰', '程野'],
    year: 2020,
    region: '中国台湾',
    tags: ['家庭', '亲情', '女性'],
    rating: 8.6,
    popularity: 66,
    updateDate: '2020-05-19',
    status: '全12集',
    isClassic: true,
    episodes: [
      ep(1, '寻人', '柳棠依据一张旧照片找到了这个镇子。'),
      ep(2, '不认识', '母亲在门口说不认识她。'),
      ep(3, '租屋', '她租下隔壁的一间空房。'),
      ep(4, '一个男孩', '母亲的小儿子每天放学都会经过她的窗。'),
      ep(5, '菜市场', '两人在摊位前第一次说了超过三句话。'),
      ep(6, '证据', '福利院的档案被她藏进了箱底。'),
      ep(7, '一场病', '母亲病倒，是她把孩子送回的家。'),
      ep(8, '门里门外', '母亲第一次给她倒了一杯水。'),
      ep(9, '告诉我', '她终于把照片放在了桌上。'),
      ep(10, '为什么', '母亲给出的理由，比她想的更普通。'),
      ep(11, '回家的路', '两人一起走完了当年她走过的那段路。'),
      ep(12, '不必强求', '她搬走了，但留下了一个电话号码。'),
    ],
  },
  {
    id: 'qing-yu-zhi-jian',
    title: '情与之间',
    poster: 'https://readdy.ai/api/search-image?query=Cinematic%20poster%20of%20a%20couple%20standing%20apart%20in%20a%20bright%20empty%20room%20with%20large%20windows%2C%20neutral%20cream%20and%20muted%20terracotta%20palette%2C%20restrained%20relationship%20drama%20aesthetic%2C%20soft%20daylight%2C%20distance%20and%20quiet%20tension&width=600&height=900&seq=ethics-poster-15&orientation=portrait',
    backdrop: 'https://readdy.ai/api/search-image?query=Minimal%20bright%20empty%20apartment%20with%20large%20windows%20and%20soft%20daylight%2C%20two%20distant%20figures%20standing%20at%20opposite%20ends%20of%20the%20room%2C%20neutrally%20warm%20cream%20and%20muted%20terracotta%20palette%2C%20restrained%20relationship%20drama%20film%20still%2C%20clean%20composition&width=1600&height=900&seq=ethics-hero-15&orientation=landscape',
    summary: '两个互相克制的中年人，在一段漫长的友情里始终没能说出那句话。',
    synopsis:
      '建筑师方其与医生周念是二十年的朋友。他们彼此了解，互相扶持，却始终没有跨过那条界线。当周念决定接受一份外地的工作，两人最后一次见面，在空荡的展厅里看完了自己年轻时的照片。剧集以大量日常细节与留白，讲述成年人之间那种既不浓烈也不消散的情感，以及克制本身是否也是一种选择。',
    director: '方岑',
    writer: '何念',
    cast: ['方其', '周念白', '林书'],
    year: 2025,
    region: '中国大陆',
    tags: ['情感', '都市', '文艺'],
    rating: 8.2,
    popularity: 80,
    updateDate: '2025-03-08',
    status: '更新至07集',
    isClassic: false,
    episodes: [
      ep(1, '二十年', '展览开幕那天，他站在人群外等她。'),
      ep(2, '电话', '她在深夜打来电话，只说了一件小事。'),
      ep(3, '搬家', '她决定离开这座城市。'),
      ep(4, '照片', '展厅里挂着一张二十年前的合影。'),
      ep(5, '界线', '他第一次把话说到了那个边界上。'),
      ep(6, '最后一个晚上', '两人在空荡的展厅里坐到很晚。'),
      ep(7, '机场', '她过了安检，没有回头。'),
    ],
  },
  {
    id: 'jin-xiu-zhi-jia',
    title: '锦绣之家',
    poster: 'https://readdy.ai/api/search-image?query=Period%20drama%20poster%20of%20an%20elegant%20matriarch%20in%20embroidered%20deep%20red%20silk%20robe%20standing%20in%20a%20lush%20family%20mansion%20courtyard%2C%20rich%20crimson%20and%20warm%20gold%20palette%2C%20dramatic%20soft%20lighting%2C%20classic%20chinese%20family%20saga%20aesthetic&width=600&height=900&seq=ethics-poster-16&orientation=portrait',
    backdrop: 'https://readdy.ai/api/search-image?query=Opulent%20chinese%20family%20mansion%20courtyard%20at%20golden%20hour%20with%20carved%20wooden%20screens%20and%20deep%20crimson%20lanterns%2C%20warm%20gold%20light%20on%20polished%20stone%20floor%2C%20rich%20bordeaux%20and%20amber%20palette%2C%20grand%20period%20family%20saga%20film%20still%2C%20elegant%20atmosphere&width=1600&height=900&seq=ethics-hero-16&orientation=landscape',
    summary: '一座老宅，三代女主人，用六十年时间讲透一个家族的兴衰与人情。',
    synopsis:
      '故事从民国末年讲起，跨越六十年，围绕着一座锦绣宅院的三代女主人展开。祖母守住了家业，母亲守住了体面，到了孙女这一代，她要面对的是放下。剧集通过三代人在同一间厅堂里的不同选择，呈现中国家族伦理的变迁：什么是家，谁有资格留下，以及在人情与规矩之间，一个人究竟有多少余地。',
    director: '张怀瑾',
    writer: '顾锦书',
    cast: ['殷素秋', '岑锦', '钟灵'],
    year: 2019,
    region: '中国大陆',
    tags: ['年代', '家族', '女性'],
    rating: 9.0,
    popularity: 72,
    updateDate: '2019-09-27',
    status: '全24集',
    isClassic: true,
    episodes: [
      ep(1, '入宅', '新嫁娘踏进锦绣宅院的第一步，门槛很高。'),
      ep(2, '分家', '族里第一次提出分家。'),
      ep(3, '一件旗袍', '旗袍上的刺绣，是祖母亲手做的。'),
      ep(4, '账房', '账房先生在深夜里来敲门。'),
      ep(5, '远客', '一位从海外回来的远亲住了下来。'),
      ep(6, '厅堂', '三代女主人第一次同席而坐。'),
      ep(7, '离开', '长孙女收拾好行李，站在楼梯口。'),
      ep(8, '钥匙', '祖母把立柜的钥匙交给了她。'),
      ep(9, '锦绣', '宅院挂牌那天，院子里开满了一树花。'),
      ep(10, '后来', '很多年后，这里成了一间小小的私人博物馆。'),
    ],
  },
  {
    id: 'san-yue-de-ni',
    title: '三月的你',
    poster: 'https://readdy.ai/api/search-image?query=Warm%20cinematic%20poster%20of%20a%20young%20woman%20in%20a%20soft%20cream%20sweater%20standing%20among%20blooming%20plum%20branches%20in%20March%2C%20soft%20pastel%20peach%20and%20muted%20sage%20tones%2C%20gentle%20film%20aesthetic%2C%20hopeful%20delicate%20mood&width=600&height=900&seq=ethics-poster-17&orientation=portrait',
    backdrop: 'https://readdy.ai/api/search-image?query=Soft%20spring%20scene%20of%20blooming%20plum%20branches%20in%20a%20quiet%20town%20square%20in%20March%2C%20gentle%20morning%20haze%2C%20pastel%20peach%20and%20muted%20sage%20palette%20with%20hint%20of%20crimson%2C%20delicate%20cinematic%20film%20still%2C%20hopeful%20calm%20atmosphere&width=1600&height=900&seq=ethics-hero-17&orientation=landscape',
    summary: '一个选择放弃婚姻的女人，在三月的城市里重新学着一个人生活。',
    synopsis:
      '三十四岁的裴知夏在三月办完了离婚手续。没有撕扯，没有争夺，她只是搬进了一间带阳台的小房子，重新开始学着关掉手机的免打扰、自己做饭、独自看电影。剧集没有跌宕的情节，只有一连串极小的生活细节：一次超市里的犹豫、一场和母亲的争吵、一个终于说出口的拒绝。它想说的是，一个人重新站起来，往往不需要戏剧性的转折。',
    director: '颜知夏',
    writer: '颜知夏',
    cast: ['裴夏', '苏明烨', '程安'],
    year: 2025,
    region: '中国大陆',
    tags: ['女性', '都市', '情感'],
    rating: 8.3,
    popularity: 87,
    updateDate: '2025-04-22',
    status: '更新至09集',
    isClassic: false,
    episodes: [
      ep(1, '三月', '她一个人拉着行李箱搬进了一间小房子。'),
      ep(2, '一个人的饭', '第一次做饭，米放多了。'),
      ep(3, '母亲', '母亲打来电话，问的不是她过得好不好。'),
      ep(4, '旧同事', '在一次饭局上，她学会了第一次转身离开。'),
      ep(5, '阳台', '阳台上多了一盆开花的植物。'),
      ep(6, '一个人看电影', '她在影院里哭得毫无征兆。'),
      ep(7, '一次拒绝', '她第一次对亲近的人说不。'),
      ep(8, '重新开始', '她把从前那间房的钥匙寄了出去。'),
      ep(9, '三月的你', '楼下的花开了，她出门散步没有带伞。'),
    ],
  },
  {
    id: 'an-liu',
    title: '暗流',
    poster: 'https://readdy.ai/api/search-image?query=Dark%20cinematic%20poster%20of%20a%20man%20in%20a%20dark%20suit%20standing%20at%20the%20edge%20of%20a%20still%20river%20at%20night%2C%20deep%20charcoal%20and%20dark%20crimson%20tones%2C%20subtle%20fog%2C%20tense%20thriller%20drama%20aesthetic%2C%20dramatic%20moody%20lighting&width=600&height=900&seq=ethics-poster-18&orientation=portrait',
    backdrop: 'https://readdy.ai/api/search-image?query=Night%20river%20bank%20in%20a%20city%20with%20still%20dark%20water%20reflecting%20faint%20amber%20distant%20lights%2C%20thick%20low%20fog%2C%20one%20figure%20standing%20at%20the%20edge%2C%20deep%20charcoal%20and%20dark%20crimson%20palette%2C%20tense%20thriller%20cinematic%20film%20still&width=1600&height=900&seq=ethics-hero-18&orientation=landscape',
    summary: '一家老三线工厂的改制，让三个老同事在利益与情义之间走到了临界点。',
    synopsis:
      '改革开放背景下，一家国营机械厂面临改制，厂长、车间主任与总工程师三个共事多年的老同事，被推到了彼此的对立面。有人想趁机入主，有人只想保住工人的饭碗，有人只想让技术留在这条生产线上。暗流之下，没有绝对的好人，也没有纯粹的坏人，每个人都在自己的位置上做出最像自己的选择。',
    director: '关山',
    writer: '贾和平',
    cast: ['程守义', '钟建国', '白洁'],
    year: 2018,
    region: '中国大陆',
    tags: ['年代', '现实', '职场'],
    rating: 8.5,
    popularity: 60,
    updateDate: '2018-11-08',
    status: '全16集',
    isClassic: true,
    episodes: [
      ep(1, '改制通知', '厂门口贴出了第一张红纸。'),
      ep(2, '三个人', '老同事坐在一起，谁也没有先开口。'),
      ep(3, '饭碗', '工人们围住了办公楼。'),
      ep(4, '技术', '总工程师把图纸锁进了抽屉。'),
      ep(5, '饭局', '酒桌上说了一句让人记住十年的话。'),
      ep(6, '女儿', '厂长的女儿成了谈判的筹码。'),
      ep(7, '夜里的电话', '凌晨三点，电话响了七声。'),
      ep(8, '投票', '全厂职工投票，结果出人意料。'),
      ep(9, '交接', '交接那天，车间里异常安静。'),
      ep(10, '生产线', '机器重新开动，声音很大。'),
    ],
  },
  {
    id: 'yu-ni-tong-xing',
    title: '与你同行',
    poster: 'https://readdy.ai/api/search-image?query=Cinematic%20poster%20of%20an%20elderly%20man%20and%20a%20young%20girl%20walking%20together%20on%20a%20tree-lined%20street%20in%20warm%20afternoon%20light%2C%20soft%20amber%20and%20sage%20tones%2C%20heartwarming%20realist%20drama%20aesthetic%2C%20gentle%20hopeful%20mood&width=600&height=900&seq=ethics-poster-19&orientation=portrait',
    backdrop: 'https://readdy.ai/api/search-image?query=Long%20tree-lined%20street%20in%20warm%20late%20afternoon%20light%20with%20a%20distant%20elderly%20man%20and%20a%20child%20walking%20side%20by%20side%2C%20golden%20amber%20and%20soft%20sage%20palette%2C%20gentle%20dappled%20light%2C%20heartwarming%20realist%20film%20still&width=1600&height=900&seq=ethics-hero-19&orientation=landscape',
    summary: '一位退休教师和邻居家的小女孩，用一个夏天教会彼此如何告别。',
    synopsis:
      '退休教师严伯廉的妻子去世后，他每天坐在楼下的长椅上发呆。邻居家的八岁女孩小满因为父母忙于工作，常常独自一人。一个偶然的下午，两人因为一只走失的狗认识了。整个夏天，他们一起走过很多路，讲了很多话。当小满一家要搬走时，严伯廉终于说出了自己一直没有说的那件事。剧集温柔却不刻意煽情，讲的是陪伴本身的分量。',
    director: '任怀安',
    writer: '任怀安',
    cast: ['严伯廉', '任小满', '陈静'],
    year: 2022,
    region: '中国大陆',
    tags: ['温情', '家庭', '成长'],
    rating: 8.8,
    popularity: 68,
    updateDate: '2022-09-06',
    status: '全8集',
    isClassic: true,
    episodes: [
      ep(1, '长椅', '他每天都坐在同一张长椅上。'),
      ep(2, '走失的狗', '一个下午，两个人在小区里找了很久。'),
      ep(3, '一个夏天', '小满开始每天放学后来找他。'),
      ep(4, '讲过的故事', '他把自己年轻时的故事讲了三遍。'),
      ep(5, '搬走', '小满的父母说，他们要搬去别的城市。'),
      ep(6, '最后一条路', '两人走完了那条走了很多次的路。'),
      ep(7, '那件事', '他终于说出妻子最后说的话。'),
      ep(8, '同行', '冬天来了，长椅上放着一封信。'),
    ],
  },
  {
    id: 'wang-shi',
    title: '往事1998',
    poster: 'https://readdy.ai/api/search-image?query=Nostalgic%20cinematic%20poster%20of%20a%20teenager%20on%20a%20bicycle%20in%20a%201990s%20chinese%20town%20street%20with%20warm%20faded%20tones%2C%20deep%20rust%20and%20cream%20palette%2C%20film%20grain%2C%20nostalgic%20coming%20of%20age%20aesthetic%2C%20soft%20late%20afternoon%20light&width=600&height=900&seq=ethics-poster-20&orientation=portrait',
    backdrop: 'https://readdy.ai/api/search-image?query=1990s%20chinese%20small%20town%20street%20at%20dusk%20with%20old%20bicycles%20and%20shop%20signs%2C%20warm%20faded%20film%20tones%2C%20deep%20rust%20and%20cream%20palette%2C%20visible%20film%20grain%2C%20nostalgic%20cinematic%20film%20still%2C%20soft%20dusty%20light&width=1600&height=900&seq=ethics-hero-20&orientation=landscape',
    summary: '一场发生在1998年夏天的意外，改变了一个小镇上四个少年的一生。',
    synopsis:
      '1998年的夏天，四个高中生在考前最后一个暑假里做了一件他们以为微不足道的事，结果酿成了无法挽回的后果。二十年后的同学聚会，四个人重新坐在同一张桌子旁。剧集在1998与2018两个时空之间来回切换，一边呈现少年时的莽撞与恐惧，一边呈现成年后的沉默与愧疚，追问的是：当没有人要求你负责时，你会不会自己去找答案。',
    director: '何越',
    writer: '何越',
    cast: ['孟舟', '陈小满', '徐立'],
    year: 2023,
    region: '中国大陆',
    tags: ['青春', '悬疑', '成长'],
    rating: 8.6,
    popularity: 84,
    updateDate: '2023-07-14',
    status: '全14集',
    isClassic: false,
    episodes: [
      ep(1, '夏天', '1998年的蝉声，比记忆里更响。'),
      ep(2, '四个人', '四个少年在河边约定了一个秘密。'),
      ep(3, '意外', '那天下午下了很大的雨。'),
      ep(4, '沉默', '没有人报警，也没有人提起。'),
      ep(5, '高考', '考场外的家长比往年多。'),
      ep(6, '离开', '四个人分别去了不同的城市。'),
      ep(7, '2018', '同学聚会的邀请发到了每个人手机上。'),
      ep(8, '第一杯酒', '饭桌上先聊了孩子和房价。'),
      ep(9, '那个人', '有人提起当年那个名字，桌子安静下来。'),
      ep(10, '录音', '一份二十年前的录音被放了出来。'),
      ep(11, '道歉', '第一次道歉，说得很艰难。'),
      ep(12, '夏天过去了', '他们一起去了那条河。'),
    ],
  },
];

export const tags = ['家庭', '亲情', '悬疑', '都市', '情感', '年代', '女性', '成长', '现实', '文艺', '青春', '群像', '温情', '职场', '婚姻', '匠人', '家族', '剧场', '悬疑', '法治', '乡土', '密室'];

export const regions = ['中国大陆', '中国台湾', '中国香港'];

export const years = [2025, 2024, 2023, 2022, 2021, 2020, 2019, 2018, 2017, 2016];

export const getDramaById = (id: string | undefined) => dramas.find((d) => d.id === id);

export const getRelatedDramas = (drama: Drama, count = 4) =>
  dramas
    .filter((d) => d.id !== drama.id)
    .map((d) => ({
      drama: d,
      score: d.tags.filter((t) => drama.tags.includes(t)).length * 10 + d.rating,
    }))
    .sort((a, b) => b.score - a.score)
    .slice(0, count)
    .map((item) => item.drama);

export const searchDramas = (keyword: string) => {
  const q = keyword.trim().toLowerCase();
  if (!q) return [];
  return dramas.filter((d) =>
    [d.title, d.director, d.writer, ...d.cast, ...d.tags, d.region, String(d.year)]
      .join(' ')
      .toLowerCase()
      .includes(q),
  );
};